
import { computed, defineComponent, onMounted, onUnmounted } from "vue";
import { useMessengerHeader } from "@/composables/messengerHeader";
import { closeDialog } from "vue3-promise-dialog";
import { QuestionMarkCircleIcon } from "@heroicons/vue/solid";
import { FocusTrap } from "@headlessui/vue";
import Button from "@/components/Button.vue";
import { css } from "@emotion/css";
import { useWidgetTheme } from "@/composables/widgetTheme";

export default defineComponent({
  name: "ConfirmModal",
  components: {
    QuestionMarkCircleIcon,
    FocusTrap,
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      default: "Confirm",
    },
    cancelLabel: {
      type: String,
      default: "Cancel",
    },
  },
  setup() {
    const { height: headerHeight, setBackAction } = useMessengerHeader();
    const { theme } = useWidgetTheme();

    const returnValue = () => true;

    const containerStyle = computed(
      () =>
        `top: ${headerHeight.value}px; height: calc(100% - ${headerHeight.value}px)`
    );

    const iconClass = computed(
      () => css`
        color: ${theme.value?.primaryColor};
      `
    );

    onMounted(() => {
      setBackAction(() => closeDialog(null));
    });

    onUnmounted(() => {
      setBackAction(null);
    });

    return {
      returnValue,
      headerHeight,
      containerStyle,
      closeDialog,
      iconClass,
    };
  },
});
